export const navigations = [
  { name: 'All Members GSC', path: '/pages/allmembersGSC', icon: 'dashboard' },
  { name: 'Spot', path: '/pages/importsports', icon: 'dashboard' },
  { name: 'User Reports', path: '/pages/userreports', icon: 'dashboard' },
  { name: 'Club', path: '/pages/cluballaccess', icon: 'dashboard' },
  { name: 'Deletion Requests', path: '/pages/deletionrequests', icon: 'dashboard' },
  { name: 'Businesses & Sponsors', path: '/pages/businesses-sponsors', icon: 'storefront' },
];

export const superAdminNavigations = [
  { name: 'Dashboard', path: '/pages/super-admin-dashboard', icon: 'bar_chart' },
  { name: 'Spot', path: '/pages/importsports', icon: 'place' },
  { name: 'Clubs', path: '/pages/admin-branches', icon: 'store' },
  { name: 'Treasury', path: '/pages/treasury', icon: 'account_balance_wallet' },
  { name: 'Deletion Requests', path: '/pages/deletionrequests', icon: 'dashboard' },
  // Re-added for testing — was removed in fc1ef9a along with Settings/Expense
  // Categories/Platform Issues. Route (/pages/messaging) was never removed, just this
  // sidebar entry, so this is a straight restore.
  { name: 'Announcement', path: '/pages/messaging', icon: 'campaign' },
  // Hidden again (was previously hidden in a4f75ff, briefly re-added for testing).
  // Route (/pages/permissions) and the page itself are untouched — only this sidebar
  // entry is commented out.
  // { name: 'Permissions', path: '/pages/permissions', icon: 'admin_panel_settings' },
];

export const branchAdminNavigations = [
  // No featureCode here on purpose — the Dashboard page itself has several independently
  // gated sections (Payments via canViewPayments, Recent Activity via canViewActivity in
  // BranchDashboard.jsx), so the nav entry to the page must stay visible regardless of any
  // one of those; activity_summary=none should only hide the Activity section inside it,
  // not the whole Dashboard link.
  { name: 'Dashboard', path: '/pages/branch-dashboard', icon: 'bar_chart' },
  { name: 'All Members GSC', path: '/pages/allmembersGSC', icon: 'dashboard', featureCode: 'member_list_profiles' },
  { name: 'User Reports', path: '/pages/userreports', icon: 'dashboard' },
  { name: 'Businesses & Sponsors', path: '/pages/businesses-sponsors', icon: 'storefront', featureCode: 'businesses_sponsors' },
  // nameForNewTier: New-tier clubs bill the owner's card in slot batches instead of each
  // member paying individually — the page still applies (it shows those owner-card
  // deductions), but "Member Payments" is the wrong name for it on this tier. See
  // Sidenav.jsx, which swaps the label based on the current club's paymentTier.
  { name: 'Member Payments', nameForNewTier: 'Club Payments', path: '/pages/member-payments', icon: 'payment', featureCode: 'payments_subscriptions' },
  { name: 'Treasury', path: '/pages/treasury', icon: 'account_balance_wallet', featureCode: 'treasury' },
  // Never previously surfaced for branch admins (see Messaging.jsx, which gates its two
  // tabs on these same feature codes) — added so a club_admin/club_staff test account can
  // see it too, matching the Super Admin restore above.
  { name: 'Announcement', path: '/pages/messaging', icon: 'campaign', featureCode: ['announcements', 'individual_messaging'] },
];
